import { FC } from 'react'
import cn from 'classnames'

import ChatBubble from '@/components/ChatBubble'
import useMessenger from '@/hooks/useMessenger'
import { MESSAGE_TYPES } from '@/context/constants'
import { IAction, IMessage, StoreContextType } from '@/context/types'
import { StoreContext } from '@/context/context'

interface TextTypeProps {
  message: IMessage
  direction: 'left' | 'right'
  context?: React.Context<StoreContextType | null>
}

const TextType: FC<TextTypeProps> = ({
  message,
  direction,
  context = StoreContext,
}) => {
  const { getSelectedConversation, sendMessage, isConversationNew, getConfig } =
    useMessenger(context)

  const handleOnClick = (action: IAction) => {
    const { text, payload } = action

    const sendPayload = {
      type: MESSAGE_TYPES.MESSAGE,
      conversationId: getSelectedConversation(),
      author: {
        type: getConfig()?.userType,
        userExternalId: getConfig()?.userExternalId,
      },
      content: {
        type: 'text',
        text,
        payload,
      },
      metadata: {
        source: 'poplar-messenger',
      },
    }

    sendMessage(sendPayload)
  }

  const renderContent = (message: IMessage) => {
    return (
      <ChatBubble direction={direction}>
        <pre className="sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03 pmui-whitespace-pre-wrap">
          <div dangerouslySetInnerHTML={{ __html: message.content?.text }} />
        </pre>
        {message.content.actions?.length > 0 && (
          <div className="pmui-mt-4">
            {message.content?.actions.map((action: IAction) => (
              <div key={`${message.id}-${action.text}`} className="pmui-mb-2">
                <button
                  className={cn('pmui-btn btn-secondary pmui-w-full', {
                    'btn-primary': action.metadata?.primary,
                  })}
                  disabled={!isConversationNew}
                  onClick={() => handleOnClick(action)}
                >
                  {action?.text}
                </button>
              </div>
            ))}
          </div>
        )}
      </ChatBubble>
    )
  }

  if (!message.content?.text) return null
  return <div>{renderContent(message)}</div>
}

export default TextType
